// assets/app.js

// --- Header Dropdown ---
function initializeHeaderDropdown() {
  const shopButton = document.getElementById('shop-menu-button');
  const shopMenu = document.getElementById('shop-menu');
  const menuRef = document.getElementById('shop-menu-container'); // Add this ID to the container div in header.liquid

  if (!shopButton || !shopMenu || !menuRef) {
    // console.log('Header dropdown elements not found');
    return;
  }

  shopButton.addEventListener('click', (event) => {
    event.stopPropagation(); // Prevent click from immediately closing the menu
    const isExpanded = shopButton.getAttribute('aria-expanded') === 'true';
    shopButton.setAttribute('aria-expanded', !isExpanded);
    shopMenu.hidden = isExpanded;
    // Toggle visibility class for potential transitions (optional)
    shopMenu.classList.toggle('opacity-0', isExpanded);
    shopMenu.classList.toggle('opacity-100', !isExpanded);
    shopMenu.classList.toggle('invisible', isExpanded);
  });

  // Close menu when clicking outside
  document.addEventListener('click', (event) => {
    if (shopButton.getAttribute('aria-expanded') === 'true' && menuRef && !menuRef.contains(event.target)) {
      shopButton.setAttribute('aria-expanded', 'false');
      shopMenu.hidden = true;
      shopMenu.classList.add('opacity-0', 'invisible');
      shopMenu.classList.remove('opacity-100');
    }
  });

  // Close menu with Escape key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && shopButton.getAttribute('aria-expanded') === 'true') {
      shopButton.setAttribute('aria-expanded', 'false');
      shopMenu.hidden = true;
      shopMenu.classList.add('opacity-0', 'invisible');
      shopMenu.classList.remove('opacity-100');
      shopButton.focus(); // Return focus to the button
    }
  });
}

// --- Product Image Gallery ---
function initializeProductGallery() {
  const gallery = document.querySelector('.product-gallery');
  if (!gallery) {
    // console.log('Product gallery not found');
    return;
  }

  const mainImage = gallery.querySelector('.main-product-image');
  const thumbnails = gallery.querySelectorAll('.thumbnail-button');
  const prevButton = gallery.querySelector('.prev-image-button');
  const nextButton = gallery.querySelector('.next-image-button');
  const thumbnailContainer = gallery.querySelector('.thumbnail-container'); // The div holding the thumbnails

  if (!mainImage || thumbnails.length === 0 || !prevButton || !nextButton || !thumbnailContainer) {
    // console.log('Product gallery sub-elements not found');
    return;
  }

  let currentImageIndex = 0;
  const images = Array.from(thumbnails).map(thumb => ({
    mainSrc: thumb.dataset.mainSrc,
    mainSrcset: thumb.dataset.mainSrcset, // Get srcset for main image
    thumbSrc: thumb.querySelector('img').src,
    alt: thumb.querySelector('img').alt
  }));

  function updateMainImage(index) {
    if (index < 0 || index >= images.length) return;

    mainImage.src = images[index].mainSrc;
    mainImage.srcset = images[index].mainSrcset || ''; // Update srcset
    mainImage.alt = images[index].alt;
    currentImageIndex = index;

    // Update thumbnail borders
    thumbnails.forEach((thumb, idx) => {
      thumb.classList.toggle('border-gray-400', idx === currentImageIndex);
      thumb.classList.toggle('border-transparent', idx !== currentImageIndex);
      thumb.setAttribute('aria-current', idx === currentImageIndex ? 'true' : 'false');
    });

     // Scroll thumbnail into view if needed
     const activeThumbnail = thumbnails[currentImageIndex];
     if (activeThumbnail) {
       const containerRect = thumbnailContainer.getBoundingClientRect();
       const thumbRect = activeThumbnail.getBoundingClientRect();
       const scrollPadding = 5; // Add some padding to the scroll

       if (thumbRect.right > containerRect.right - scrollPadding) {
         thumbnailContainer.scrollLeft += thumbRect.right - containerRect.right + scrollPadding;
       } else if (thumbRect.left < containerRect.left + scrollPadding) {
         thumbnailContainer.scrollLeft -= containerRect.left - thumbRect.left + scrollPadding;
       }
     }
  }

  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', () => {
      updateMainImage(index);
    });
     // Set initial border state
     thumbnail.classList.toggle('border-gray-400', index === currentImageIndex);
     thumbnail.classList.toggle('border-transparent', index !== currentImageIndex);
     thumbnail.setAttribute('aria-current', index === currentImageIndex ? 'true' : 'false');
  });

  prevButton.addEventListener('click', () => {
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    updateMainImage(newIndex);
  });

  nextButton.addEventListener('click', () => {
    const newIndex = (currentImageIndex + 1) % images.length;
    updateMainImage(newIndex);
  });

  // Initialize first image
  if (images.length > 0) {
    updateMainImage(0);
  }
}


// --- Initialize all components on page load ---
function initializeComponents() {
    initializeHeaderDropdown();
    initializeProductGallery();
    // Add calls to initialize other JS components if needed
}

// Run initializers on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeComponents);
} else {
  initializeComponents();
}


// --- Handle Shopify Theme Editor changes ---
// Re-initialize components when the theme editor updates a section
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section.id.includes('header')) {
      initializeHeaderDropdown();
    }
    if (section.id.includes('main-product')) {
       initializeProductGallery();
    }
    // Add re-initialization for other sections if necessary
  });

  // Optional: Re-initialize on block select/deselect if needed
  // document.addEventListener('shopify:block:select', (event) => { ... });
  // document.addEventListener('shopify:block:deselect', (event) => { ... });
}
